/* 🤖 this file was generated by svg-to-ts */
export const matIconSignalCellularOff: {
  name: 'signal-cellular-off';
  data: string;
} = {
  name: 'signal-cellular-off',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m21 1-8.31 8.31 8.31 8.3zM4.91 4.36 3.5 5.77l6.36 6.37L1 21h17.73l2 2 1.41-1.41z"/></svg>`
};
